import { render, staticRenderFns } from "./ConstructionNewPage.vue?vue&type=template&id=32981ab4&"
import script from "./ConstructionNewPage.vue?vue&type=script&lang=ts&"
export * from "./ConstructionNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports